import { render, staticRenderFns } from "./ProcessingQueue.vue?vue&type=template&id=b4d308f4&scoped=true"
import script from "./ProcessingQueue.vue?vue&type=script&lang=ts"
export * from "./ProcessingQueue.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d308f4",
  null
  
)

export default component.exports